import React from 'react';
import HeroSection from '../components/Sections/HeroSection';
import SectionHeader from '../components/Sections/SectionHeader';

const Careers = () => {
  const currentOpenings = [
    {
      title: 'React JS Developer',
      department: 'Web Development',
      experience: '2-4 years',
      location: 'Chennai (Remote Possible)',
      type: 'Full-time'
    },
    {
      title: 'UI/UX Designer',
      department: 'Design',
      experience: '1-3 years',
      location: 'Chennai',
      type: 'Full-time'
    },
    {
      title: 'Digital Marketing Executive',
      department: 'Marketing',
      experience: '1-2 years',
      location: 'Chennai (Remote Possible)',
      type: 'Full-time'
    },
    {
      title: 'HR Recruiter',
      department: 'HR Consultancy',
      experience: 'Fresher to 1 year',
      location: 'Chennai',
      type: 'Full-time'
    },
    {
      title: 'Content Writer',
      department: 'Content',
      experience: '1-2 years',
      location: 'Remote',
      type: 'Part-time'
    },
    {
      title: 'Intern - Full Stack Development',
      department: 'Training',
      experience: 'Fresher',
      location: 'Chennai',
      type: 'Internship'
    }
  ];

  const benefits = [
    {
      icon: '💼',
      title: 'Career Growth',
      description: 'Clear progression paths and promotion opportunities'
    },
    {
      icon: '🎓',
      title: 'Learning & Development',
      description: 'Regular training and skill enhancement programs'
    },
    {
      icon: '🏥',
      title: 'Health Insurance',
      description: 'Comprehensive medical coverage for you and family'
    },
    {
      icon: '💰',
      title: 'Competitive Salary',
      description: 'Industry-standard compensation with regular reviews'
    },
    {
      icon: '🎯',
      title: 'Performance Bonus',
      description: 'Quarterly and annual performance incentives'
    },
    {
      icon: '🎉',
      title: 'Work-Life Balance',
      description: 'Flexible hours and remote work options'
    }
  ];

  return (
    <div>
      <HeroSection
        title="Grow With Us"
        subtitle="Join our team of innovators and problem-solvers"
        showButtons={false}
      />

      {/* Why Work at MPEOPLES */}
      <section className="py-5">
        <div className="container">
          <SectionHeader 
            title="Why Work at MPEOPLES?"
            subtitle="We believe in empowering our people to do their best work"
          />
          
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h4 className="fw-bold mb-4">Our Culture</h4>
              <p className="mb-4">
                At MPEOPLES, we foster a culture of innovation, collaboration, and continuous learning. 
                We believe that great ideas can come from anywhere, and we empower every team member 
                to contribute to our success.
              </p>
              <p className="mb-4">
                Our <strong>"Powered by the People, for the People"</strong> philosophy extends to our 
                workplace too. We value diversity, encourage open communication, and celebrate 
                achievements together.
              </p>
              <div className="row">
                <div className="col-6 text-center">
                  <div className="display-4 fw-bold text-primary">50+</div>
                  <p className="text-muted">Team Members</p>
                </div>
                <div className="col-6 text-center">
                  <div className="display-4 fw-bold text-primary">4.5★</div>
                  <p className="text-muted">Employee Satisfaction</p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="card border-0 shadow-lg">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-4">Employee Benefits</h5>
                  <div className="row g-3">
                    {benefits.map((benefit, index) => (
                      <div key={index} className="col-md-6">
                        <div className="d-flex align-items-start">
                          <span className="display-6 me-3">{benefit.icon}</span>
                          <div>
                            <h6 className="fw-bold mb-1">{benefit.title}</h6>
                            <p className="text-muted small mb-0">{benefit.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Current Openings */}
      <section className="py-5 bg-light">
        <div className="container">
          <SectionHeader 
            title="Current Openings"
            subtitle="Find your perfect role with us"
          />
          
          <div className="row g-4">
            {currentOpenings.map((job, index) => (
              <div key={index} className="col-lg-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h5 className="fw-bold mb-1">{job.title}</h5>
                        <p className="text-muted mb-0">{job.department}</p>
                      </div>
                      <span className={`badge ${job.type === 'Internship' ? 'bg-warning' : 'bg-success'}`}>
                        {job.type}
                      </span>
                    </div>
                    
                    <div className="row mb-4">
                      <div className="col-6">
                        <small className="text-muted">Experience</small>
                        <p className="mb-0 fw-bold">{job.experience}</p>
                      </div>
                      <div className="col-6">
                        <small className="text-muted">Location</small>
                        <p className="mb-0 fw-bold">{job.location}</p>
                      </div>
                    </div>
                    
                    <div className="d-flex justify-content-between">
                      <button className="btn btn-outline-primary">
                        View Details
                      </button>
                      <button className="btn btn-primary">
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Apply */}
      <section className="py-5">
        <div className="container">
          <SectionHeader 
            title="How to Apply"
            subtitle="Our simple application process"
          />
          
          <div className="row">
            <div className="col-md-3">
              <div className="text-center p-3">
                <div className="rounded-circle bg-primary d-inline-flex align-items-center justify-content-center mb-3" 
                     style={{ width: '60px', height: '60px' }}>
                  <span className="text-white fw-bold">1</span>
                </div>
                <h6 className="fw-bold">Find Your Role</h6>
                <p className="text-muted small">Browse openings and find the perfect match</p>
              </div>
            </div>
            
            <div className="col-md-3">
              <div className="text-center p-3">
                <div className="rounded-circle bg-primary d-inline-flex align-items-center justify-content-center mb-3" 
                     style={{ width: '60px', height: '60px' }}>
                  <span className="text-white fw-bold">2</span>
                </div>
                <h6 className="fw-bold">Submit Application</h6>
                <p className="text-muted small">Fill the form with your details and resume</p>
              </div>
            </div>
            
            <div className="col-md-3">
              <div className="text-center p-3">
                <div className="rounded-circle bg-primary d-inline-flex align-items-center justify-content-center mb-3" 
                     style={{ width: '60px', height: '60px' }}>
                  <span className="text-white fw-bold">3</span>
                </div>
                <h6 className="fw-bold">Interview Process</h6>
                <p className="text-muted small">Technical and HR discussions</p>
              </div>
            </div>
            
            <div className="col-md-3">
              <div className="text-center p-3">
                <div className="rounded-circle bg-primary d-inline-flex align-items-center justify-content-center mb-3" 
                     style={{ width: '60px', height: '60px' }}>
                  <span className="text-white fw-bold">4</span>
                </div>
                <h6 className="fw-bold">Onboarding</h6>
                <p className="text-muted small">Welcome to the MPEOPLES family!</p>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-5">
            <h5 className="fw-bold mb-3">Don't see your perfect role?</h5>
            <p className="lead mb-4">
              We're always looking for talented people. Send us your resume anyway!
            </p>
            <button className="btn btn-primary btn-lg">
              Send General Application
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;